// from https://github.com/awslabs/aws-mobile-appsync-sdk-js#creating-a-client

import { ApolloProvider } from "@apollo/client/react/context/ApolloProvider"
import React, { ReactNode } from "react"
import { getApolloClient } from "../api/apolloClient"
import { useSession } from "next-auth/react"
import { useTestingContext } from "@web/context/TestingContext"

export const ApolloClientProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { data: session } = useSession()
  const { appSyncApiKey } = useTestingContext()
  const client = React.useMemo(() => getApolloClient(session, appSyncApiKey), [appSyncApiKey]) // eslint-disable-line react-hooks/exhaustive-deps
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
